const PENDING_KEY = "solvook_signup_pending";
/**
 * "이번 세션에서 방금 가입했다" 는 표식. 가입 API 성공 직후 심는다.
 *
 * 프로필 설정 화면은 신규 가입자만 오는 곳이 아니다 — 프로필이 비어 있는 기존 회원도 전역
 * 가드(`useProfileGuard`)가 여기로 보낸다. 표식 없이 발사하면 그 기존 회원이 신규 가입으로
 * 집계되므로, 표식이 있을 때만 발사하고 한 번 쓰면 지운다.
 *
 * 가입 수단을 값으로 담는 이유 — 프로필 완료 시점에는 카카오/휴대폰 중 무엇으로 가입했는지
 * 알 수 없다. `providerId` 는 카카오·웨일만 값이 있고 휴대폰 가입은 비어 있다.
 *
 * `userId` 까지 묶는 이유 — 로그아웃(`AuthStore.logout`)은 sessionStorage 를 지우지 않는다.
 * 가입만 하고 프로필을 비운 채 이탈한 뒤 같은 탭에서 다른 계정으로 로그인하면, 그 사람이
 * 프로필을 마칠 때 남의 표식을 주워 신규 가입으로 집계된다.
 */ export const markSignupPending = (method, userId)=>{
    try {
        sessionStorage.setItem(PENDING_KEY, JSON.stringify({
            method,
            userId
        }));
    } catch (e) {
    // 스토리지가 차단된 환경. 이벤트는 포기하되 가입 플로우는 막지 않는다
    }
};
/**
 * 표식을 읽고 지운다. 없거나 다른 유저의 것이면 null — 발사하지 않는다.
 * 남의 표식도 지우고 넘어간다. 남겨두면 다음 사람이 또 주워간다.
 */ export const consumeSignupPending = (userId)=>{
    try {
        const stored = sessionStorage.getItem(PENDING_KEY);
        if (!stored) return null;
        sessionStorage.removeItem(PENDING_KEY);
        const pending = JSON.parse(stored);
        return pending.userId === userId ? pending.method : null;
    } catch (e) {
        return null;
    }
};
const GRADE_PREFIX = {
    middle: "중",
    high: "고"
};
const GRADE_NUMBER = {
    10: "1",
    20: "2",
    30: "3"
};
/**
 * 광고 타겟용 학년 라벨. `schoolGrade`(10/20/30)만으로는 학년 숫자뿐이라 학교급과 합쳐야
 * '고1' 이 된다. 대학(`univ`)은 학년 축이 없어 null.
 */ export const toGradeLabel = (level, grade)=>{
    if (!level || !grade) return null;
    const prefix = GRADE_PREFIX[level];
    return prefix ? "".concat(prefix).concat(GRADE_NUMBER[grade]) : null;
};
/**
 * payload 조립. 화면에서 떼어내 순수 함수로 둔다 — 학교 조인·대표 학교 선택·직업별 null 분기가
 * 여기 모여 있어, 테스트가 붙는 자리는 컴포넌트가 아니라 이쪽이다.
 */ export const buildSignupPayload = (param)=>{
    let { method , userId , profile , education  } = param;
    const schoolNames = profile.school.map((item)=>item.name);
    var _profile_userType, _profile_subject, _schoolNames_;
    return {
        method,
        user_id: userId,
        job: (_profile_userType = profile.userType) !== null && _profile_userType !== void 0 ? _profile_userType : null,
        subject: (_profile_subject = profile.subject) !== null && _profile_subject !== void 0 ? _profile_subject : null,
        education: education !== null && education !== void 0 ? education : null,
        grade: toGradeLabel(education, profile.grade),
        school: schoolNames.join(",") || null,
        school_primary: (_schoolNames_ = schoolNames[0]) !== null && _schoolNames_ !== void 0 ? _schoolNames_ : null,
        school_count: schoolNames.length
    };
};
export const trackSignupCompleted = (payload)=>{
    var _window_gtag, _window_dataLayer;
    (_window_gtag = window.gtag) === null || _window_gtag === void 0 ? void 0 : _window_gtag.call(window, "event", "sign_up", payload);
    (_window_dataLayer = window.dataLayer) === null || _window_dataLayer === void 0 ? void 0 : _window_dataLayer.push({
        event: "sign_up_completed",
        ...payload
    });
};
